module.exports = __webpack_public_path__ + "img/dpsy-photo1.411fabc4.png";